// extracted by mini-css-extract-plugin
export default {"overlay":"mz-z","bodyOpen":"nz-z","content":"oz-z","header":"pz-z","close":"qz-z","closeNoHeading":"rz-z"};